import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import callApi from "../../../Apis/callApi";
import ContentBody from "../../../Components/Content/ContentBody";
import ContentHead from "../../../Components/Content/ContentHead";
import InputField from "../../../Components/InputField";
import Content from "../../../Components/Content/Content";
import Button from "../../../Components/Button";
import Social from "../Social";
import styles from "../../../Styles/inputField.module.css";
import { getExtendedFileName } from "../../../Utils/ImageHelper";
import UploadImage from "../../../Utils/UploadImage";
import Loading from "../../../Components/Loading";

// interface UpdateCompanyProps {}

const UpdateCompany = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      getData();
    }
  }, []);

  const getData = () => {
    callApi({
      url: "getCompanyById/" + id,
      method: "get",
      type: "company",
    })
      .then((res) => {
        console.log("company data", res);
        setValues({
          date: "",
          companyName: res.data.data.companyName,
          compantLogo: "",
          address: res.data.data.address,
          city: res.data.data.city,
          country: res.data.data.country,
          pincode: res.data.data.pincode,
          landline: res.data.data.landline,
          mobile: res.data.data.mobile,
          emailAdd1: res.data.data.emailAdd1,
          emailAdd2: res.data.data.emailAdd2,
        });
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong while fetching data!");
      });
  };

  const [values, setValues] = useState({
    date: "",
    companyName: "",
    compantLogo: "",
    address: "",
    city: "",
    country: "",
    pincode: "",
    landline: "",
    mobile: "",
    emailAdd1: "",
    emailAdd2: "",
  });

  const {
    date,
    companyName,
    compantLogo,
    address,
    city,
    country,
    pincode,
    landline,
    mobile,
    emailAdd1,
    emailAdd2,
  } = values;

  const [social, setSocial] = useState([{ name: "", url: "" }]);

  const handleAdd = () => {
    setSocial((prev: any) => {
      prev.push({ name: "", url: "" });
      return [...prev];
    });
  };

  const updateName = (e: any, index: number) => {
    setSocial((prev: any) => {
      prev[index][e.target.name] = e.target.value;
      return [...prev];
    });
  };

  const handleRemove = (index: number) => {
    setSocial((prev: any) => {
      prev.splice(index, 1);
      return [...prev];
    });
  };

  const onChange = (e: any) => {
    let name = e.target.name;
    let value = name === "compantLogo" ? e.target.files[0] : e.target.value;
    setValues({ ...values, [name]: value });
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    if (e.target.name === "discard") {
      setValues({
        date: "",
        companyName: "",
        compantLogo: "",
        address: "",
        city: "",
        country: "",
        pincode: "",
        landline: "",
        mobile: "",
        emailAdd1: "",
        emailAdd2: "",
      });
      navigate("/company-data");
    } else if (e.target.name === "update") {
      let compLogo = getExtendedFileName(compantLogo);

      UploadImage({ file: compantLogo, name: compLogo })
        .then(() => {
          callApi({
            url: `updateCompany/${id}`,
            method: "patch",
            type: "company",
            data: {
              ...values,
              socialMedia: social,
              compantLogo: compLogo,
            },
            header: true,
          })
            .then((_res: any) => {
              setValues({
                date: "",
                companyName: "",
                compantLogo: "",
                address: "",
                city: "",
                country: "",
                pincode: "",
                landline: "",
                mobile: "",
                emailAdd1: "",
                emailAdd2: "",
              });

              toast.success("Successfully Updated!");
            })
            .catch((_e) => {
              toast.error("Something went wrong!");
            });
        })
        .catch((_e) => {
          toast.error("Something went wrong!");
        });
    }
  };

  return (
    <>
      <Loading isLoading={loading} />
      <Content>
        <ContentHead
          title="Update Company Data"
          showBtn1={true}
          btn1Name="update"
          btn1type="filled"
          btn1Text="Update"
          onClickHandler={handleClick}
          showBtn2={true}
          btn2Name="discard"
          btn2Text="Discard"
          btn2type="outlined"
        />
        <ContentBody>
          <div
            style={{
              display: "grid",
              rowGap: 12,
              gridAutoRows: "auto",
            }}
          >
            <InputField
              isLabel={false}
              value={date}
              lable={"Date"}
              type={"date"}
              isRequired={false}
              placeholder={"Date"}
              name={"date"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={companyName}
              lable={"Company Name"}
              type={"text"}
              isRequired={false}
              placeholder={"Company Name"}
              name={"companyName"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <div className={styles.field_contianer}>
              <label style={{ fontWeight: 500 }} htmlFor="">
                Company Logo
              </label>
              <input
                type="file"
                name="compantLogo"
                accept="image"
                onChange={onChange}
              />
            </div>
            <InputField
              isLabel={false}
              value={address}
              lable={"Address"}
              type={"text"}
              isRequired={false}
              placeholder={"Address"}
              name={"address"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={city}
              lable={"City"}
              type={"text"}
              isRequired={false}
              placeholder={"City"}
              name={"city"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={country}
              lable={"Country"}
              type={"text"}
              isRequired={false}
              placeholder={"Country"}
              name={"country"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={pincode}
              lable={"Pincode"}
              type={"text"}
              isRequired={false}
              placeholder={"Pincode"}
              name={"pincode"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={landline}
              lable={"Landline"}
              type={"text"}
              isRequired={false}
              placeholder={"Landline"}
              name={"landline"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={mobile}
              lable={"Mobile"}
              type={"text"}
              isRequired={false}
              placeholder={"Mobile"}
              name={"mobile"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={emailAdd1}
              lable={"Email Address 1"}
              type={"text"}
              isRequired={false}
              placeholder={"Email Address 1"}
              name={"emailAdd1"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={emailAdd2}
              lable={"Email Address 2"}
              type={"text"}
              isRequired={false}
              placeholder={"Email Address 2"}
              name={"emailAdd2"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <label
              htmlFor=""
              style={{
                fontWeight: 500,
              }}
            >
              Social Media
            </label>
            <Button
              text={"Add More"}
              type={"outlined"}
              name={"add"}
              clickHandler={handleAdd}
              isIcon=""
              style={{
                padding: "4px 12px",
                marginBottom: 20,
              }}
            />
            <div
              style={{
                display: "grid",
                gridAutoFlow: "row",
                rowGap: 28,
              }}
            >
              {social.map((item: any, index: number) => {
                return (
                  <Social
                    data={item}
                    index={index}
                    remove={handleRemove}
                    updateName={(e: any) => updateName(e, index)}
                    updateTag={setSocial}
                  />
                );
              })}
            </div>
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default UpdateCompany;
